import { render, staticRenderFns } from "./materia-form.vue?vue&type=template&id=57f908bb&scoped=true"
import script from "./materia-form.vue?vue&type=script&lang=js"
export * from "./materia-form.vue?vue&type=script&lang=js"
import style0 from "./materia-form.vue?vue&type=style&index=0&id=57f908bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f908bb",
  null
  
)

export default component.exports